<template>
  <div />
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'SignInPage',

    computed: {
      ...mapGetters('session', ['session']),
      ...mapGetters('merchant', ['loyaltyOptions']),

      isLoyaltySignOnEnabled() {
        return this.loyaltyOptions.supportsLoyaltySso;
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (!this.session.isSignedIn) {
          if (this.isLoyaltySignOnEnabled) {
            this.$openModal('single-sign-on-modal');
          }
          else {
            this.$openModal('signIn');
          }
        }

        this.$router.replace({
          name: 'orderMenu',
          params: {
            merchantId: this.$route.params.merchantId
          }
        });
      }
    }
  };
</script>
